export default "__VITE_ASSET__HwNJYyvO__"